import { render } from "./qualityInspection2.vue?vue&type=template&id=793a7843&scoped=true"
import script from "./qualityInspection2.vue?vue&type=script&lang=js"
export * from "./qualityInspection2.vue?vue&type=script&lang=js"

import "./qualityInspection2.vue?vue&type=style&index=0&id=793a7843&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-793a7843"

export default script